export const SITE_TYPES = {
  SET_DATA: 'SET_SITE_DATA',
  SET_LOCALE: 'SET_SITE_LOCALE',
  SET_LOADING: 'SET_SITE_LOADING',
}
